import { colors } from '../levels/levels';

export const getStrokeForColor = (color) => {
    switch (color) {
        case colors.red:
            return "#97213f";
        case colors.blue:
            return "#235dc8";
    }
}

export const getColorName = (color) => {
    switch (color) {
        case colors.blue:
            return "blue";
        case colors.red:
            return "red";
        case colors.black:
            return "black";
        case colors.cyan:
            return "cyan";
        case colors.green:
            return "green";
        case colors.orange:
            return "orange";
        case colors.white:
            return "white";
        case colors.yellow:
            return "yellow";
    }
}
